import { LocationTypeIds } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const transformClubLocations = (locations) => {
    return locations.map(location => ({
        ...location,
        facilities: [],
    }));
};

export const sortClubLocations = (locations = []) => {
    return [...locations]
        .sort((a, b) => {
            // 1️ Primary locations first
            if (a.locationTypeId !== b.locationTypeId) {
                return a.locationTypeId === LocationTypeIds.PRIMARY ? -1 : 1;
            }

            // 2 Then by location name (A–Z)
            return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
        })
        .map((location) => ({
            ...location,
            // 3 Sort facilities by name (A–Z)
            facilities: [...(location.facilities || [])].sort((f1, f2) => f1.name.localeCompare(f2.name, undefined, { sensitivity: 'base' })),
        }));
};
